export default function EmptyStateCard({
  icon: Icon,
  // Illustration de marque : quand elle est fournie, elle remplace la pastille
  // à icône — plus parlante sur les écrans qui parlent de commandes.
  image,
  imageAlt = '',
  title,
  description,
  actionLabel,
  onAction,
  tone = 'neutral',
}) {
  const tones = {
    neutral: {
      iconBg: '#f1f5f9',
      iconColor: '#94a3b8',
      titleColor: '#475569',
      descColor: '#94a3b8',
      actionBg: '#eff6ff',
      actionBorder: '#bfdbfe',
      actionColor: '#173b78',
    },
    info: {
      iconBg: '#eef4ff',
      iconColor: '#2a66b8',
      titleColor: '#173b78',
      descColor: '#64748b',
      actionBg: '#eff6ff',
      actionBorder: '#bfdbfe',
      actionColor: '#173b78',
    },
    success: {
      iconBg: '#ecfdf5',
      iconColor: '#15803d',
      titleColor: '#166534',
      descColor: '#64748b',
      actionBg: '#f0fdf4',
      actionBorder: '#bbf7d0',
      actionColor: '#15803d',
    },
  };

  const style = tones[tone] || tones.neutral;

  return (
    <div style={{ background: 'white', borderRadius: '16px', padding: '48px 24px', textAlign: 'center', border: '1px solid #eef0f6' }}>
      {image ? (
        <img
          src={image}
          alt={imageAlt}
          width="72"
          height="72"
          loading="lazy"
          style={{ width: '72px', height: '72px', objectFit: 'contain', display: 'block', margin: '0 auto 14px', opacity: 0.9 }}
        />
      ) : (
        <div style={{ width: '56px', height: '56px', borderRadius: '16px', background: style.iconBg, display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 14px' }}>
          {Icon ? <Icon size={24} color={style.iconColor} /> : null}
        </div>
      )}
      <div style={{ fontSize: '14px', fontWeight: 700, color: style.titleColor, marginBottom: description ? '6px' : 0 }}>
        {title}
      </div>
      {description ? (
        <div style={{ fontSize: '12px', color: style.descColor, lineHeight: 1.5, whiteSpace: 'pre-line' }}>
          {description}
        </div>
      ) : null}
      {actionLabel && onAction ? (
        <button
          onClick={onAction}
          style={{
            marginTop: '16px',
            padding: '9px 14px',
            borderRadius: '10px',
            border: `1.5px solid ${style.actionBorder}`,
            background: style.actionBg,
            color: style.actionColor,
            fontSize: '12px',
            fontWeight: 700,
            cursor: 'pointer',
          }}
        >
          {actionLabel}
        </button>
      ) : null}
    </div>
  );
}
